export const SECONDS_60 = 60000;
